import React, { FC } from 'react';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { loadSingleBatch } from '@reducers/batch';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface ProductionOrderDetailsNCFileTimelineProps extends ProductionOrderScreenProps {
}

const ProductionOrderDetailsNCFileTimelineComponent: FC<ProductionOrderDetailsNCFileTimelineProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
    getAllNcFiles: false,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
     <MultiMachineTimeline />
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsNCFileTimeline = connect(null, {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsNCFileTimelineComponent);

export { ProductionOrderDetailsNCFileTimeline };
